<template>
  <div class="offers-info-card">
    <div class="offers-info-card__title-box">
      <app-title-box
        :is-tooltip="true"
        tooltip="Подробная информация и показатели продукции."
        title="Характеристики"
      ></app-title-box>
    </div>
    <div class="offers-info-card__content">
      <div class="offers-info-card__img-box">
        <div
          class="offers-info-card__img-box-img"
          :class="hasPhoto"
          :style="{ 'background-image': 'url(\'' + image + '\')' }"
          @click="isOpenPopupImage"
        >
          <div class="offers-info-card__img-box-icon-wrapper" v-if="photo">
            <app-svg-icon
              isCurrentColor
              name="magnifying-glass"
              class="offers-info-card__img-box-icon"
            ></app-svg-icon>
          </div>
          <div v-if="currentDate" class="offers-info-card__img-box-date">
            {{ currentDate }}
          </div>
        </div>
      </div>
      <ul class="offers-info-card__info-block">
        <li
          v-if="response.sellerContractor && response.sellerContractor.name"
          class="offers-info-card__info-block-row"
        >
          <span class="offers-info-card__info-block-header-item">
            Продавец
          </span>
          <router-link
            :to="
              $options.LANDINGS.find(
                (el) => el.id === response.sellerContractor.id
              ).link
            "
            v-if="hasLanding"
            class="offers-info-card__info-block-value"
          >
            {{ response.sellerContractor.name }}
            <img
              :src="`/static/images/logos/${response.sellerContractor.id}.png`"
              alt=""
              class="offers-info-card__info-block-logo"
            />
          </router-link>
          <span v-else class="offers-info-card__info-block-value">
            {{ response.sellerContractor.name }}
            <img
              :src="`/static/images/logos/${response.sellerContractor.id}.png`"
              alt=""
              class="offers-info-card__info-block-logo"
            />
          </span>
        </li>
        <li v-if="response.name" class="offers-info-card__info-block-row">
          <span class="offers-info-card__info-block-header-item">
            Сокращенное название
          </span>
          <span class="offers-info-card__info-block-value">
            {{ response.name }}
          </span>
        </li>
        <li class="offers-info-card__info-block-row">
          <span class="offers-info-card__info-block-header-item">ПТФ</span>
          <span class="offers-info-card__info-block-value">
            {{ response.cfpp }}
          </span>
        </li>
        <li class="offers-info-card__info-block-row" v-if="!perPiece">
          <span class="offers-info-card__info-block-header-item">
            Плотность
          </span>
          <span class="offers-info-card__info-block-value">
            {{ response.density.toFixed(3) }}
          </span>
        </li>
        <li
          v-if="response.supplier && response.supplier.name"
          class="offers-info-card__info-block-row"
        >
          <span class="offers-info-card__info-block-header-item"
            >Поставщик</span
          >
          <span class="offers-info-card__info-block-value">
            {{ response.supplier.name }}
          </span>
        </li>
        <li class="offers-info-card__info-block-row">
          <span class="offers-info-card__info-block-header-item"
            >Организация</span
          >
          <span class="offers-info-card__info-block-value">
            {{ contractor }}
          </span>
        </li>
        <li class="offers-info-card__info-block-row">
          <span class="offers-info-card__info-block-header-item">Склад</span>
          <span class="offers-info-card__info-block-value">
            {{ warehouse }}
          </span>
        </li>
        <li v-if="region" class="offers-info-card__info-block-row">
          <span class="offers-info-card__info-block-header-item">Округ</span>
          <span class="offers-info-card__info-block-value">
            {{ region | firstWords() }}
          </span>
        </li>
        <li class="offers-info-card__info-block-row">
          <span class="offers-info-card__info-block-header-item">
            Способ доставки
          </span>
          <span class="offers-info-card__info-block-value">{{ shipping }}</span>
        </li>
        <li
          class="offers-info-card__info-block-row"
          v-if="response.pricePerTonne"
        >
          <span class="offers-info-card__info-block-header-item">
            Цена за тонну
          </span>
          <div class="offers-info-card__price-block">
            <template v-if="!response.priceOnDemand">
              <span class="offers-info-card__info-block-value">
                {{ response.pricePerTonne | price() }}
              </span>
              <span
                :class="getClassChangePrice(response.priceChangePerTonne)"
                class="offers-info-card__info-block-value"
              >
                {{ response.priceChangePerTonne }}
              </span>
            </template>
            <template v-else>
              <span>по запросу</span>
            </template>
          </div>
        </li>
        <li
          class="offers-info-card__info-block-row"
          v-if="response.pricePerLiter && showLtDensity(response.density, 'lt')"
        >
          <span class="offers-info-card__info-block-header-item">
            Цена за литр
          </span>
          <div class="offers-info-card__price-block">
            <template v-if="!response.priceOnDemand">
              <span class="offers-info-card__info-block-value">
                {{ response.pricePerLiter }}
              </span>
              <span
                :class="getClassChangePrice(response.priceChangePerLiter)"
                class="offers-info-card__info-block-value"
              >
                {{ response.priceChangePerLiter }}</span
              ></template
            >
            <template v-else>
              <span>по запросу</span>
            </template>
          </div>
        </li>
        <li
          class="offers-info-card__info-block-row"
          v-if="response.pricePerPiece"
        >
          <span class="offers-info-card__info-block-header-item">
            Цена за штуку
          </span>
          <div class="offers-info-card__price-block">
            <span class="offers-info-card__info-block-value">
              {{ response.pricePerPiece | price }}
            </span>
          </div>
        </li>
        <template v-if="isSeller">
          <li class="offers-info-card__info-block-row">
            <span class="offers-info-card__info-block-header-item">
              Количество дней на оплату
            </span>
            <span class="offers-info-card__info-block-value">
              {{ response.paymentDelay }}
            </span>
          </li>
          <li class="offers-info-card__info-block-row">
            <span class="offers-info-card__info-block-header-item">
              Количество дней на выборку
            </span>
            <span class="offers-info-card__info-block-value">
              {{ response.shipmentDelay }}
            </span>
          </li>
        </template>
        <template v-else>
          <li class="offers-info-card__info-block-row">
            <span class="offers-info-card__info-block-header-item">
              Крайний срок оплаты
            </span>
            <span class="offers-info-card__info-block-value">
              {{ response.paymentDeadline | dateFormat() }}
            </span>
          </li>
          <li class="offers-info-card__info-block-row">
            <span class="offers-info-card__info-block-header-item">
              Крайний срок выгрузки
            </span>
            <span class="offers-info-card__info-block-value">
              {{ response.shipmentDeadline | dateFormat() }}
            </span>
          </li>
        </template>
        <li v-if="status" class="offers-info-card__info-block-row">
          <span class="offers-info-card__info-block-header-item">Статус</span>
          <span class="offers-info-card__info-block-value">
            {{ $options.STATUSES[status] }}
          </span>
        </li>
      </ul>
    </div>
    <div class="offers-info-card__button-box">
      <div class="offers-info-card__button-box-btn">
        <app-button-control
          :disabled="disabled"
          type="green-border"
          :route="`/offers/price/${id}`"
          v-if="!response.priceOnDemand"
        >
          График цен
        </app-button-control>
      </div>
      <div class="offers-info-card__button-box-btn" v-if="$development">
        <app-button-control
          is-disabled
          type="link"
          class="offers-info-card__button"
        >
          Все характеристики
        </app-button-control>
      </div>
    </div>
  </div>
</template>

<script>
import { getClassChangePrice, yandexMetrikaEcommerce } from '@/helpers';
import imageUrl from '@/assets/image/no-photo.png';
import { shippingOptions } from '@/helpers/enums/delivery';
import { SELLER_OFFER_STATUS } from '@/helpers/enums/statuses';
import { LANDINGS } from '@/helpers/enums/landings';

export default {
  name: 'OffersInfoCard',
  components: {
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    AppTitleBox: () => import('@/components/common/AppTitleBox'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  props: {
    isSeller: {
      type: Boolean,
    },
    response: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 0,
    },
    slug: {
      type: String,
      default: '',
    },
    photo: {
      type: String,
      default: '',
    },
    warehouse: {
      type: String,
      default: '',
    },
    contractor: {
      type: String,
      default: '',
    },
    region: {
      type: String,
      default: '',
    },
    date: {
      type: [String, Date],
      default: '03.11.2020',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    shipping: '',
  }),
  computed: {
    hasLanding() {
      return this.$options.LANDINGS.some(
        (el) => el.id === this.response?.sellerContractor.id
      );
    },
    perPiece() {
      return this.response?.priceType === 'perPiece';
    },
    /**
     * Изображение
     */
    image() {
      return this.photo ? this.photo : imageUrl;
    },
    /**
     * Указывает класс если нет фото
     */
    hasPhoto() {
      return {
        'offers-info-card__img-box-img--no-photo': !this.photo,
      };
    },
    /**
     * Форматированная дата
     */
    currentDate() {
      return this.date ? this.$options.filters.dateFormat(this.date) : '';
    },
  },
  created() {
    this.$options.STATUSES = SELLER_OFFER_STATUS;
    this.$options.LANDINGS = LANDINGS;

    if (this.response.sellerContractor === null) {
      this.response.sellerContractor = {
        id: 0,
        name: 'ООО "РЕСУРС"',
      };
    }
    this.shipping = this.response.shippingOptions
      .map((el) => shippingOptions[el])
      .join(', ');
    if (!this.isSeller) {
      this.yandexMetrikaEcommerce('detail', [
        {
          id: this.id.toString(),
          name: this.response.fullName,
        },
      ]);
    }
  },
  methods: {
    yandexMetrikaEcommerce,
    getClassChangePrice,

    /**
     * Показать литры в зависимости от плотности
     */
    showLtDensity(density, name) {
      if (name === 'lt' && density === 1) {
        return false;
      }
      return true;
    },
    /**
     * Открытие модального окна
     * TODO: заменить вызов модалки
     */
    isOpenPopupImage() {
      if (this.photo) {
        this.$modal.show('popup-image', {
          img: this.photo,
          date: this.currentDate,
          title: '',
        });
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
.offers-info-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 288px;
  padding: 10px 10px 12px;
  padding-left: 242px;

  @include media-md() {
    min-height: 266px;
    padding-left: 212px;
  }

  @include media-sm() {
    min-height: 217px;
    padding-left: 171px;
  }

  @include media-xs() {
    padding-left: 12px;
  }

  &__title-box {
    margin: 13px 0 7px;

    @include media-sm() {
      margin-top: 0;
    }

    @include media-xs() {
      margin-bottom: 16px;
    }
  }

  &__content {
    flex-grow: 1;
    font-weight: 300;

    @include media-xs() {
      display: flex;
      margin-bottom: 21px;
    }

    @include media-xxs() {
      flex-direction: column;
    }
  }

  &__info-block {
    @include list-reset;

    display: flex;
    flex-direction: column;
    margin-bottom: 8px;
    font-size: rem(14);

    @include media-sm() {
      flex-grow: 1;
      font-size: rem(12);
    }

    @include media-xs() {
      margin-bottom: 0;
    }

    @include media-xxs() {
      font-size: rem(13);
    }
  }

  &__info-block-row {
    display: flex;
    padding: 6px 0;

    @include media-sm() {
      padding: 4px 0;
    }

    @include media-xxs() {
      flex-wrap: wrap;
      padding: 0;
      margin-bottom: 16px;
    }
  }

  &__info-block-header-item {
    width: 100%;
    line-height: 16px;
    color: $color-black;
    letter-spacing: 0.03em;
    opacity: 0.5;

    @include media-xxs() {
      max-width: 100%;
      margin-bottom: 5px;
    }
  }

  &__info-block-logo {
    display: block;
    max-height: 25px;
    margin-top: 10px;
  }

  &__info-block-value {
    width: 100%;
    line-height: 1.2;
    color: #000;
    letter-spacing: 0.03em;
    opacity: 0.8;
  }

  &__price-block {
    display: flex;
    width: 100%;
  }

  &__button {
    padding: 0 !important;
  }

  &__button-box {
    display: flex;
    align-items: center;

    @include media-xs() {
      justify-content: space-between;
    }

    &-btn {
      display: flex;
      width: 100%;

      .app-button-control {
        font-size: rem(12);
        font-weight: 500;
        text-transform: uppercase;

        @include media-md {
          padding: 0 18px;
        }

        @include media-xs {
          height: 30px;
          font-size: rem(10);
        }
      }

      &:first-of-type {
        @include media-xs {
          margin-right: 31px;
        }

        @include media-xxs() {
          margin-right: 0;
        }
      }

      @include media-xs() {
        width: auto;
      }
    }

    .app-button-control--link {
      font-size: rem(13);
      text-transform: none;
    }
  }

  &__img-box {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 200px;
    height: 268px;

    @include media-md() {
      width: 182px;
      height: 244px;
    }

    @include media-sm() {
      width: 145px;
      height: 194px;
    }

    @include media-xs() {
      position: relative;
      top: 0;
      left: 0;
      flex-shrink: 0;
      width: 116px;
      height: 156px;
      margin-right: 16px;
    }

    @include media-xxs() {
      width: 182px;
      height: 244px;
      margin: auto;
      margin-bottom: 15px;
    }
  }

  &__img-box-icon-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    color: $color-white;
    background-color: $overlay-transparent-2;
    border-radius: 50%;
    transition: color $A;
    transform: translate(-50%, -50%);

    @include media-xs() {
      width: 36px;
      height: 36px;
    }
  }

  &__img-box-img {
    position: relative;
    width: 100px;
    width: 100%;
    height: 100px;
    height: 100%;
    cursor: pointer;
    background-position: center;
    background-size: cover;

    &--no-photo {
      cursor: auto;
    }

    &:hover {
      .offers-info-card__img-box-icon-wrapper {
        color: $color-brand-green;
      }
    }
  }

  &__img-box-icon {
    width: 22px;
    height: 22px;

    @include media-xs() {
      width: 15px;
      height: 15px;
    }
  }

  &__img-box-date {
    position: absolute;
    bottom: 4px;
    left: 4px;
    padding: 0 7px;
    font-size: rem(12);
    font-weight: 600;
    line-height: 21px;
    color: $color-white;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 2px;
  }
}
</style>
